// Page: entry-returning  (login / returning-user page)
//
// Ported from the inline <script> in
//   Enrollment_modules/entry-returning/login.module/module.html (lines 48–2061).
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes,
// consistent with the pilot (docs/handoff/global-js-deep-refactor-notes.md):
//   1. Selectors scoped to the HubSpot render-time wrapper id
//      `#page_0_returning_user_widget` are now scoped to `root` (the element
//      carrying data-ea-module), via the q/qi/qa helpers. Genuinely page-global
//      selectors stay document-scoped exactly as the original: the initial
//      view-toggle over the sibling entry widgets (`#Page_0_Enter_Zip_widget`,
//      `#Page_0_Project_Found_widget`, `#Page_0_Project_not_Found_widget`) and
//      this module's own page-level widget wrapper (`#page_0_returning_user_widget`),
//      the `#Page_0_Project_Found_widget #addressAppend` cross-widget write, the
//      overlay/loader ids read via getElementById, `body`, and the button/anchor
//      NodeLists.
//   2. `_hcms/api/*` fetches → apiUrl(...) and same-origin JS redirects
//      (https://enrollment.nautilussolar.com/<path>) → root-relative "/<path>".
//   3. Inline HubDB URLs → hubdbRowsUrl(tableKey, {...}) from core/hubdb
//      (brokerAttribution, utilityFarm, utilityAvailability, usageConfig,
//      paymentConfig, lmiCensus) — all keys already present in templates/partials/env.html.
//   4. `validatePass` is imported from ui/validation (was the temporary window shim).
//   5. localStorage → core/storage: `get`/`set` for keys in the StorageKey union,
//      `rawGet`/`rawSet`/`rawRemove` for the many login-only keys not in it,
//      `clear()` for localStorage.clear().
//
// `crypt` (crypto-js) is still provided by the crypto-js CDN + `var crypt` glue
// script left in module.html; it is declared ambiently in global.d.ts. This
// module also defines its own IndexedDB `clearDatabase()` (ported below as a
// local function), unlike other pages that only call the ambient global.
//
// NOTE (latent bugs preserved from the original inline script, documented inline):
//   - `fillLocalStorage` reads three variables (`limitt`, `offsett`, `allFarmRowss`)
//     and calls `checkUtilityIdInFarmTable` that the inline script never declared.
//   - `CheckDealStageAndRedirectAccordingly` awaits a bare `delay(9000)` that the
//     inline script never declared.
// Dynamic ES5 vars and API/HubDB row shapes are typed `any` to keep the port
// mechanical.

import { apiUrl } from "../../core/api"
import { hubdbRowsUrl } from "../../core/hubdb"
import * as storage from "../../core/storage"
import { validatePass } from "../../ui/validation"

// config is unused: the original inline script read everything from localStorage
// and window.__ENV__ (zero HubL tokens), so there are no HubL values to pass in.
export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/entry/entry-returning.ts","init",[root,_config],["root","_config"]);
  // ─── Scoped DOM helpers ──────────────────────────────────────────────────────
  const q = (sel: string) => root.querySelector(sel) as HTMLElement
  const qi = (sel: string) => root.querySelector(sel) as HTMLInputElement
  const qa = (sel: string) => root.querySelectorAll(sel)
  const di = (id: string) => document.getElementById(id) as HTMLElement
  const fieldVal = (sel: string): string => String($(sel).val() ?? "")

  // ─── Shared state (was module-scoped in the inline script) ────────────────────
  let responseFromAPI: any = ""
  let pwd: any
  let utilityIdSession: any
  let LmiAvailability: any
  let LmiCensusAvailability: any
  const DisplayLmiElementList: any[] = []
  const requireLmiElementList: any[] = []
  const DisplayUsageElementList: any[] = []
  const requireUsageElementList: any[] = []
  const DisplayConsentElementList: any[] = []
  const requireConsentElementList: any[] = []
  let consetPaymentReq: any
  let LMICensusTractLevels: any
  let sampleSessiontype: any
  let sampleOriginType: any
  let errorCount = 0
  let log_Utname: any
  let globalDealId: any
  // Second (duplicate) block of `var` declarations in the original inline script.
  // `utilityIdSession`/`LmiAvailability`/`LmiCensusAvailability` were re-declared
  // (harmless in ES5); the two lists below are only referenced by the dead
  // getAvailability/checkLMIConfigurationVariation path.
  const DisplayElementList: any[] = []
  const requireElementList: any[] = []
  void DisplayLmiElementList
  void requireLmiElementList
  void LMICensusTractLevels
  void utilityIdSession

  // ─── Loaders (page-global overlays) ───────────────────────────────────────────
  function returningUserOpenLoader(): void {
__ea_trace("modules/entry/entry-returning.ts","returningUserOpenLoader",[],[]);
    const loader = di("returningUserLoader")
    const body = document.querySelector("body")
    void body
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("RUloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }
  function returningUsercloseLoader(): void {
__ea_trace("modules/entry/entry-returning.ts","returningUsercloseLoader",[],[]);
    const loader = di("returningUserLoader")
    const body = document.querySelector("body")
    void body
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("RUloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = false
    })
  }
  function userNoLongerOpenLoader(): void {
__ea_trace("modules/entry/entry-returning.ts","userNoLongerOpenLoader",[],[]);
    const loader = di("userNoLongerLoader")
    const body = document.querySelector("body")
    void body
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("UNLloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }
  function userNoLongercloseLoader(): void {
__ea_trace("modules/entry/entry-returning.ts","userNoLongercloseLoader",[],[]);
    const loader = di("userNoLongerLoader")
    const body = document.querySelector("body")
    void body
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("UNLloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = false
    })
  }

  // ─── Field validation ─────────────────────────────────────────────────────────
  function validateEmail(): void {
__ea_trace("modules/entry/entry-returning.ts","validateEmail",[],[]);
    const email = qi("#email").value.trim()
    if (email === "") {
      q("#email_error_message").innerHTML = "Please enter your Email Id."
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      q("#email_error_message").innerHTML = "Please enter a valid email address."
    } else {
      q("#email_error_message").innerHTML = ""
    }
  }

  function validatePasswordRU(): void {
__ea_trace("modules/entry/entry-returning.ts","validatePasswordRU",[],[]);
    const password = qi("#password").value
    const validPassword = validatePass(password)
    if (validPassword.valid) {
      q("#password_error_message").innerHTML = ""
    } else {
      q("#password_error_message").innerHTML = validPassword.errors[0]
    }
    // (original left an alternate inline-regex password check commented out here)
  }

  function validateForm(): boolean {
__ea_trace("modules/entry/entry-returning.ts","validateForm",[],[]);
    q("#password3rdTime_error_message").innerHTML = ""
    validateEmail()
    validatePasswordRU()
    const errorMessages = qa(".error-message")
    let hasErrors = false
    for (let i = 0; i < errorMessages.length; i++) {
      if (errorMessages[i].innerHTML !== "") {
        hasErrors = true
        break
      }
    }
    if (hasErrors) {
      return false
    } else {
      CheckIfUserExist()
      return true
    }
  }

  // ─── Password decrypt helper ──────────────────────────────────────────────────
  function dp(val: any): void {
__ea_trace("modules/entry/entry-returning.ts","dp",[val],["val"]);
    pwd = crypt.decrypt(val)
  }

  // ─── Deal / contact flow ──────────────────────────────────────────────────────
  async function getUtilityNameFromDeal(dealId: any): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","getUtilityNameFromDeal",[dealId],["dealId"]);
    globalDealId = dealId
    try {
      const data = { deal_id: dealId }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      const dataa = await response.json()
      if (dataa.message === "No User Found") {
        // (original left this branch empty)
      } else if (dataa.message === "User Found") {
        log_Utname = dataa.userValue.properties.utility_name
        const log_repid = dataa.userValue.properties.attribution_rep
        const log_attcode = dataa.userValue.properties.attribution_code
        const log_refUrl = dataa.userValue.properties.referral_url
        const l_dealId = dataa.userValue.id
        const usage_period_from = dataa.userValue.properties.usage_period_from
        const usage_period_to = dataa.userValue.properties.usage_period_to
        const usage_period_days = dataa.userValue.properties.usage_period_days
        const electricity_consumption_wh = dataa.userValue.properties.electricity_consumption_wh
        const electricity_consumption_davg_wh = dataa.userValue.properties.electricity_consumption_davg_wh
        const electricity_consumption_watts = dataa.userValue.properties.electricity_consumption_watts
        const electricity_consumption_kwh = dataa.userValue.properties.electricity_consumption_kwh
        const electricity_consumption_davg_kwh = dataa.userValue.properties.electricity_consumption_davg_kwh
        const electricity_consumption_kwatts = dataa.userValue.properties.electricity_consumption_kwatts
        const payment_amount_per_kwh = dataa.userValue.properties.payment_amount_per_kwh
        const sub_sizing_factor = dataa.userValue.properties.sub_sizing_factor
        void sub_sizing_factor
        const subscription_size_kwac = dataa.userValue.properties.subscription_size_kwac
        const gross_electricity_production = dataa.userValue.properties.gross_electricity_production
        const utility_rate = dataa.userValue.properties.utility_rate
        const postal_code = dataa.userValue.properties.postal_code
        const estimatedAnnualEleCost = gross_electricity_production * utility_rate
        storage.rawSet("usage_period_from", usage_period_from)
        storage.rawSet("usage_period_to", usage_period_to)
        storage.rawSet("usage_period_days", usage_period_days)
        storage.rawSet("electricity_consumption_Wh", electricity_consumption_wh)
        storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_wh)
        storage.rawSet("electricity_consumption_Watts", electricity_consumption_watts)
        storage.rawSet("electricity_consumption_kWh", electricity_consumption_kwh)
        storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kwh)
        storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kwatts)
        storage.rawSet("subscription_size_kWAC", subscription_size_kwac)
        storage.rawSet("gross_electricity_production", gross_electricity_production)
        storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
        storage.rawSet("estimatedAnnualEleCost", String(estimatedAnnualEleCost))
        storage.set("zip_code", postal_code)

        let address1 = dataa.userValue.properties.street_address
        let address2 = dataa.userValue.properties.street_address_2
        const county = dataa.userValue.properties.county
        const city = dataa.userValue.properties.city
        if (
          address1 !== "" &&
          address1 != null &&
          address1 !== undefined &&
          address1 !== "null" &&
          address1 !== "undefined"
        ) {
          address1 = address1
        } else {
          address1 = ""
        }
        if (
          address2 !== "" &&
          address2 != null &&
          address2 !== undefined &&
          address2 !== "null" &&
          address2 !== "undefined"
        ) {
          address2 = `, ${address2}`
        } else {
          address2 = ""
        }
        storage.rawSet("Street Address", address1 + address2)
        storage.set("county", county)
        storage.rawSet("city", city)
        if (log_Utname != null) {
          storage.set("utility_Name", log_Utname)
        }
        if (log_attcode != null) {
          if (log_attcode.trim() !== "") {
            if (log_attcode !== "null") {
              storage.set("repid", log_repid)
              storage.set("attcode", log_attcode)
              storage.set("referralUrl", log_refUrl)

              const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
                attribution_code: log_attcode,
              })
              fetch(hubDBEndpoint, { method: "GET" })
                .then((response) => response.json())
                .then((data) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[data],["data"]);
                  const rows = data.objects
                  if (rows.length >= 1) {
                    for (let i = 0; i < rows.length; i++) {
                      const element = rows[i]
                      if (element.values["5"].includes(log_repid) && element.values["5"].includes(log_attcode)) {
                        const brokerRepPhoneNo = element.values["6"]
                        const brokerRepEmail = element.values["7"]
                        const brokerRepTitle = element.values["9"]
                        const brokerRepName = element.values["4"]
                        const brokerCompany = element.values["2"]
                        if (element.values["8"] !== undefined) {
                          const brokerRepImage = element.values["8"].url
                          storage.rawSet("brokerRepImage", brokerRepImage)
                        }
                        if (element.values["13"] !== undefined) {
                          const brokerMeetingUrl = element.values["13"].url
                          storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                        }
                        storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                        storage.rawSet("brokerRepEmail", brokerRepEmail)
                        storage.rawSet("brokerRepTitle", brokerRepTitle)
                        if (brokerRepName !== undefined) {
                          storage.rawSet("brokerRepName", brokerRepName)
                        }
                        storage.rawSet("brokerCompany", brokerCompany)
                        storage.rawSet("sidebarBrokerDisplay", "Yes")
                        break
                      } else {
                        if (i === rows.length - 1) {
                          // Code to execute on the last iteration
                          for (let k = 0; k < rows.length; k++) {
                            const elementt = rows[k]
                            if (elementt.values["5"].includes(log_attcode)) {
                              if (elementt.values["12"] === 1) {
                                const brokerRepPhoneNo = elementt.values["6"]
                                const brokerRepEmail = elementt.values["7"]
                                const brokerRepTitle = elementt.values["9"]
                                const brokerRepName = elementt.values["4"]
                                const brokerCompany = elementt.values["2"]
                                if (elementt.values["8"] !== undefined) {
                                  const brokerRepImage = elementt.values["8"].url
                                  storage.rawSet("brokerRepImage", brokerRepImage)
                                }
                                if (elementt.values["13"] !== undefined) {
                                  const brokerMeetingUrl = elementt.values["13"].url
                                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                                }
                                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                                storage.rawSet("brokerRepEmail", brokerRepEmail)
                                storage.rawSet("brokerRepTitle", brokerRepTitle)
                                if (brokerRepName !== undefined) {
                                  storage.rawSet("brokerRepName", brokerRepName)
                                }
                                storage.rawSet("brokerCompany", brokerCompany)
                                storage.rawSet("sidebarBrokerDisplay", "Yes")
                                break
                              } else {
                                if (k === rows.length - 1) {
                                  storage.rawRemove("attcode")
                                  storage.rawRemove("repid")
                                  storage.rawSet("sidebarBrokerDisplay", "No")
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    storage.rawRemove("attcode")
                    storage.rawRemove("repid")
                    storage.rawSet("sidebarBrokerDisplay", "No")
                  }
                })
            }
          }
        }
        storage.set("dealId", l_dealId)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  async function findAssociatedDeals(contactId: any, email: any): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","findAssociatedDeals",[contactId,email],["contactId","email"]);
    let catchdata: any = ""
    try {
      const data = { contactId: contactId }
      const response = await fetch(apiUrl("FetchAssociatedDealsBasedOnContactId"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      const dealRecordLength = dataa.userValue.associations.deals.results.length
      if (dealRecordLength === 1) {
        const dealIdLog = dataa.userValue.associations.deals.results
        for (let i = 0; i < dealIdLog.length; i++) {
          const deal = dealIdLog[i].id
          try {
            const data = { deal_id: deal }
            const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            })
            const dataa = await response.json()
            responseFromAPI = JSON.stringify(dataa)
            if (dataa.message === "No User Found") {
              returningUsercloseLoader()
              q("#userNotExist").innerHTML =
                "We were unable to find an account using that user name and password. Please try again or use Forgot Password."
            } else if (dataa.message === "User Found") {
              const l_dealStage = dataa.userValue.properties.dealstage
              const uan_1_value = dataa.userValue.properties.uan_1_value
              const uan_2_value = dataa.userValue.properties.uan_2_value
              void uan_2_value
              const impact_referral = dataa.userValue.properties.impact_referral
              let impact_click_id = dataa.userValue.properties.impact_click_id
              const poSuVeRe = dataa.userValue.properties.post_submission_verification_reason

              storage.rawSet("uan1Value", uan_1_value)
              storage.rawSet("uan2Value", uan_1_value)
              if (impact_referral === "Yes") {
                storage.set("isImpact", impact_referral)
              } else {
                storage.set("isImpact", "No")
              }
              if (impact_click_id === "null" || impact_click_id == null) {
                impact_click_id = ""
              }
              storage.set("clickId", impact_click_id)
              const eligible_for_lmi = dataa.userValue.properties.eligible_for_lmi
              if (eligible_for_lmi === true || eligible_for_lmi === "true") {
                storage.set("isLMI", "Yes")
              } else {
                storage.set("isLMI", "No")
              }

              if (poSuVeRe === "Manual Usage") {
                storage.rawSet("isManualSubmission", "Yes")
              } else {
                storage.rawSet("isManualSubmission", "No")
              }
              if (
                l_dealStage === 127892578 /* completed */ ||
                l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */ ||
                l_dealStage === 127892575 /* Staged (Sales Pipeline) */ ||
                l_dealStage === 127892570 /* Submitted (Sales Pipeline) */ ||
                l_dealStage === 127892574 /* Verified (Sales Pipeline) */ ||
                l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */ ||
                l_dealStage === 984278689 /* Submitted (IL Pipeline) */ ||
                l_dealStage === 984219225 /* Staged (IL Pipeline) */ ||
                l_dealStage === 984341032 /* Interfaced (IL Pipeline) */ ||
                l_dealStage === 984341034 /* 10. Completed (IL Pipeline) */
              ) {
                const street_address_1 = dataa.userValue.properties.street_address
                const street_address_2 = dataa.userValue.properties.street_address_2
                const service_city = dataa.userValue.properties.city
                const service_state_abbreviation = dataa.userValue.properties.service_state_abbreviation
                const county = dataa.userValue.properties.county
                const Service_postal_code = dataa.userValue.properties.postal_code
                const l_dealId = dataa.userValue.id
                const fullName = storage.get("LoggedName")
                const firstname = storage.get("FirstName")
                const lastname = storage.get("LastName")
                const dateOfBirth = storage.rawGet("DateOfBirth")
                const UserDevice_1 = storage.get("User Device")
                const BrowserName_1 = storage.get("Browser Name")
                const opratingSystem_1 = storage.get("Operating System")
                storage.clear()
                storage.set("dealId", l_dealId)
                storage.rawSet("logEmail", email)
                storage.set("contactId", contactId)
                storage.rawSet("name", fullName ?? "")
                storage.set("FirstName", firstname ?? "")
                storage.set("LastName", lastname ?? "")
                storage.rawSet("DateOfBirth", dateOfBirth ?? "")
                storage.rawSet("first_visited_url", first_visited_url)
                storage.set("User Device", UserDevice_1 ?? "")
                storage.set("Browser Name", BrowserName_1 ?? "")
                storage.set("Operating System", opratingSystem_1 ?? "")
                storage.set("county", county)
                storage.rawSet(
                  "Address",
                  `${street_address_1}, ${street_address_2}, ${service_city}, ${service_state_abbreviation}`,
                )
                storage.rawSet("Street Address", `${street_address_1} ${street_address_2}`)
                const checkZC = storage.get("zip_code")
                storage.rawSet("city", service_city)
                if (checkZC == null) {
                  if (Service_postal_code != null || Service_postal_code !== "") {
                    storage.set("zip_code", Service_postal_code)
                  }
                }
                returningUsercloseLoader()
                window.location.href = "/dashboard"
              } else {
                await getUtilityNameFromDeal(deal)
              }
            }
          } catch (error) {
            console.error("Error:", error)
          }
          break
        }
      } else if (dealRecordLength > 1) {
        const dealIdLog = dataa.userValue.associations.deals.results
        for (let i = 0; i < dealIdLog.length; i++) {
          const deal = dealIdLog[i].id
          let catchdata: any = ""
          try {
            const data = { deal_id: deal }
            const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            })
            catchdata = data
            const dataa = await response.json()
            responseFromAPI = JSON.stringify(dataa)
            const l_dealStage = dataa.userValue.properties.dealstage
            const street_address_1 = dataa.userValue.properties.street_address
            const street_address_2 = dataa.userValue.properties.street_address_2
            const service_city = dataa.userValue.properties.city
            const service_state_abbreviation = dataa.userValue.properties.service_state_abbreviation
            const _county = dataa.userValue.properties.county
            const Service_postal_code = dataa.userValue.properties.postal_code
            const impact_referral = dataa.userValue.properties.impact_referral
            let impact_click_id = dataa.userValue.properties.impact_click_id
            const poSuVeRe = dataa.userValue.properties.post_submission_verification_reason
            const l_dealId = dataa.userValue.id
            const fullName = storage.get("LoggedName")
            const firstname = storage.get("FirstName")
            const lastname = storage.get("LastName")
            const dateOfBirth = storage.rawGet("DateOfBirth")
            const UserDevice_1 = storage.get("User Device")
            const BrowserName_1 = storage.get("Browser Name")
            const opratingSystem_1 = storage.get("Operating System")
            storage.clear()
            storage.set("dealId", l_dealId)
            storage.rawSet("logEmail", email)
            storage.rawSet("dealStage", l_dealStage)
            storage.set("contactId", contactId)
            storage.rawSet("name", fullName ?? "")
            storage.set("FirstName", firstname ?? "")
            storage.set("LastName", lastname ?? "")
            storage.rawSet("DateOfBirth", dateOfBirth ?? "")
            storage.rawSet("first_visited_url", first_visited_url)
            storage.set("User Device", UserDevice_1 ?? "")
            storage.set("Browser Name", BrowserName_1 ?? "")
            storage.set("Operating System", opratingSystem_1 ?? "")
            storage.rawSet(
              "Address",
              `${street_address_1}, ${street_address_2}, ${service_city}, ${service_state_abbreviation}`,
            )
            storage.rawSet("Street Address", `${street_address_1} ${street_address_2}`)
            storage.rawSet("city", service_city)
            if (impact_referral === "Yes") {
              storage.set("isImpact", impact_referral)
            } else {
              storage.set("isImpact", "No")
            }
            if (impact_click_id === "null" || impact_click_id == null) {
              impact_click_id = ""
            }
            storage.set("clickId", impact_click_id)
            const checkZC = storage.get("zip_code")
            if (checkZC == null) {
              storage.set("zip_code", Service_postal_code)
            }
            const eligible_for_lmi = dataa.userValue.properties.eligible_for_lmi
            if (eligible_for_lmi === true || eligible_for_lmi === "true") {
              storage.set("isLMI", "Yes")
            } else {
              storage.set("isLMI", "No")
            }
            if (poSuVeRe === "Manual Usage") {
              storage.rawSet("isManualSubmission", "Yes")
            } else {
              storage.rawSet("isManualSubmission", "No")
            }
            returningUsercloseLoader()
            window.location.href = "/dashboard"
          } catch (error) {
            console.error("Error:", error)
          }
          break
        }
        window.location.href = "/dashboard"
      } else {
        returningUsercloseLoader()
        q("#userNotExist").innerHTML =
          "We were unable to find an account using that user name and password. Please try again or use Forgot Password."
      }
    } catch (error) {
      returningUsercloseLoader()
      console.error("Error:", error)
    }
  }

  async function CheckIfUserExist(): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","CheckIfUserExist",[],[]);
    let email = fieldVal("#loginForm #email")
    email = email.toLowerCase()
    const password = fieldVal("#loginForm #password")
    try {
      returningUserOpenLoader()
      const data = { email: email }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      const pr = dataa.userValue.properties.password
      dp(pr)
      if (dataa.message === "No User Found") {
        returningUsercloseLoader()
        q("#userNotExist").innerHTML =
          "We were unable to find an account using that user name and password. Please try again or use Forgot Password"
      } else if (dataa.message === "User Found") {
        if (pwd === password) {
          const log_utilityID = dataa.userValue.properties.enrollment_utility_id
          const log_attribution_code = dataa.userValue.properties.attribution_code
          const recordId = dataa.userValue.properties.hs_object_id
          const firstName = dataa.userValue.properties.firstname
          const lastName = dataa.userValue.properties.lastname
          const onboardToken = dataa.userValue.properties.bayou_onboarding_token
          const date_stamp = dataa.userValue.properties.date_stamp
          const bayouContactId = dataa.userValue.properties.bayou_contact_id
          const phone = dataa.userValue.properties.phone
          const cellphone = dataa.userValue.properties.mobilephone

          storage.set("RecordId", recordId)
          storage.set("LoggedName", `${firstName} ${lastName}`)
          storage.set("FirstName", firstName)
          storage.set("LastName", lastName)
          storage.set("CompanyName", `${firstName}&${lastName}`)
          storage.set("HomePhone", phone)
          storage.set("CellPhone", cellphone)

          const checkUID = storage.get("utility_id")
          const checkUN = storage.get("utility_Name")
          if (log_attribution_code != null && log_attribution_code !== "") {
            sampleOriginType = "Invite"
            sampleSessiontype = "Consumer Completing"
          } else {
            sampleOriginType = "Direct"
            sampleSessiontype = "Consumer Only"
          }
          if (checkUID == null) {
            storage.set("utility_id", log_utilityID)
          }
          if (checkUN == null) {
            storage.set("utility_Name", log_Utname)
          }
          storage.set("onboarding_token", onboardToken)
          storage.rawSet("bayou_contact_id", bayouContactId)
          storage.set("dateStamp", date_stamp)
          await findAssociatedDeals(recordId, email)
          await fillLocalStorage(log_utilityID)
          await locSaveSessionDetailsOnLocalStorage(log_utilityID)
          await addDataToContactRecord(email)
          if (storage.get("userEmail") !== email) {
            if (storage.get("skipUsage") !== null) {
              storage.remove("skipUsage")
            }
          }
          storage.set("userEmail", email.toLowerCase())
          q("#userNotExist").innerHTML = ""
          await addUserAgentData()
          const l_contactId = dataa.userValue.id
          storage.set("contactId", l_contactId)
        } else if (pr === password) {
          const log_utilityID = dataa.userValue.properties.enrollment_utility_id
          const log_attribution_code = dataa.userValue.properties.attribution_code
          const recordId = dataa.userValue.properties.hs_object_id
          const firstName = dataa.userValue.properties.firstname
          const lastName = dataa.userValue.properties.lastname
          const onboardToken = dataa.userValue.properties.bayou_onboarding_token
          const bayouContactId = dataa.userValue.properties.bayou_contact_id
          const dateOfBirth = dataa.userValue.properties.date_of_birth
          const phone = dataa.userValue.properties.phone
          const cellphone = dataa.userValue.properties.mobilephone
          storage.set("RecordId", recordId)
          storage.set("LoggedName", `${firstName} ${lastName}`)
          storage.set("FirstName", firstName)
          storage.set("LastName", lastName)
          storage.set("CompanyName", `${firstName}&${lastName}`)
          storage.rawSet("DateOfBirth", dateOfBirth)
          storage.set("HomePhone", phone)
          storage.set("CellPhone", cellphone)
          const checkUID = storage.get("utility_id")
          const checkUN = storage.get("utility_Name")
          if (log_attribution_code != null && log_attribution_code !== "") {
            sampleOriginType = "Invite"
            sampleSessiontype = "Consumer Completing"
          } else {
            sampleOriginType = "Direct"
            sampleSessiontype = "Consumer Only"
          }
          if (checkUID == null) {
            storage.set("utility_id", log_utilityID)
          }
          if (checkUN == null) {
            storage.set("utility_Name", log_Utname)
          }
          storage.set("onboarding_token", onboardToken)
          storage.rawSet("bayou_contact_id", bayouContactId)
          await findAssociatedDeals(recordId, email)
          await fillLocalStorage(log_utilityID)
          await locSaveSessionDetailsOnLocalStorage(log_utilityID)
          await addDataToContactRecord(email)
          if (storage.get("userEmail") !== email) {
            if (storage.get("skipUsage") !== null) {
              storage.remove("skipUsage")
            }
          }
          storage.set("userEmail", email.toLowerCase())
          q("#userNotExist").innerHTML = ""
          await addUserAgentData()
          const l_contactId = dataa.userValue.id
          storage.set("contactId", l_contactId)
        } else if (pwd !== password) {
          returningUsercloseLoader()
          errorCount++
          q("#password_error_message").innerHTML = "Password does not match"
          if (errorCount >= 3) {
            q("#password3rdTime_error_message").innerHTML =
              "If you are having trouble logging into your account, please reach out to us for help 1-866-969-4129"
          }
        }
      }
    } catch (error) {
      returningUsercloseLoader()
      q("#userNotExist").innerHTML =
        "We were unable to find an account using that user name and password. Please try again or use Forgot Password"
      console.error("Error:", error)
    }
  }

  async function fillLocalStorage(U_Id: any): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","fillLocalStorage",[U_Id],["U_Id"]);
    // NOTE: `limitt`, `offsett`, `allFarmRowss` and `checkUtilityIdInFarmTable`
    // were never declared in the original inline script (a latent bug — reading
    // them threw / concat-on-undefined threw, swallowed by the .catch below).
    // Declared here as undefined `any` / an empty stub to keep the port
    // compilable; the pagination branch (`rowss.length === limitt`) stays
    // effectively unreachable because `limitt` is undefined.
    let limitt: any
    const offsett: any = undefined
    void offsett
    let allFarmRowss: any
    async function checkUtilityIdInFarmTable(_uid: any): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","checkUtilityIdInFarmTable",[_uid],["_uid"]);}
    void checkUtilityIdInFarmTable

    const hubDBEndpoint = hubdbRowsUrl("utilityFarm", {
      limit: limitt,
      offset: offsett,
    })
    fetch(hubDBEndpoint, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[data],["data"]);
        const matchingRowss = data.objects.filter((row: any) => row.values[10] === U_Id)
        const rowss = data.objects
        allFarmRowss = allFarmRowss.concat(matchingRowss)
        if (rowss.length === limitt) {
          // There might be more rows, fetch the next page
          limitt += limitt
          return checkUtilityIdInFarmTable(U_Id)
        }
        const priorityArray: any[] = []
        for (let i = 0; i <= allFarmRowss.length; i++) {
          const currentobj = allFarmRowss[i]
          const FarmStateAbbreviation = currentobj.values[5]
          const FarmZip = currentobj.values[6]
          const FarmName = currentobj.values[7]
          const FarmID = currentobj.values[1]
          const priority = currentobj.values[12]
          const FarmDisplayName = currentobj.values[2]
          const FarmStreetAddress1 = currentobj.values[3]
          const FarmStreetAddress2 = currentobj.values[13]
          const FarmCity = currentobj.values[4]
          const FarmEmail = currentobj.values[28]
          const FarmPhoneNumber = currentobj.values[23]
          const FarmProjectDescription = currentobj.values[22]
          const FarmLlc = currentobj.values[21]
          const FarmLMIDiscount = currentobj.values[19]
          const FarmOpenDiscount = currentobj.values[20]
          let FarmPayment = ""
          if (currentobj.values[36] !== undefined && currentobj.values[36] !== "undefined") {
            FarmPayment = currentobj.values[36].name
          }
          const myObject = {
            FarmZip: FarmZip,
            FarmName: FarmName,
            FarmID: FarmID,
            priority: priority,
            FarmDisplayName: FarmDisplayName,
            FarmStreetAddress1: FarmStreetAddress1,
            FarmStreetAddress2: FarmStreetAddress2,
            FarmCity: FarmCity,
            FarmEmail: FarmEmail,
            FarmStateAbbreviation: FarmStateAbbreviation,
            FarmPhoneNumber: FarmPhoneNumber,
            FarmProjectDescription: FarmProjectDescription,
            FarmLlc: FarmLlc,
            FarmLMIDiscount: FarmLMIDiscount,
            FarmOpenDiscount: FarmOpenDiscount,
            FarmPayment: FarmPayment,
          }
          if (currentobj.values[9] === 1) {
            priorityArray.push(myObject)
          }
          if (i === allFarmRowss.length - 1) {
            // Now correspondingObject contains the object with the lowest priority
            const minPriorityObject = priorityArray.reduce(
              (min, obj) => (obj.priority < min.priority ? obj : min),
              priorityArray[0],
            )

            const addressAppend = document.querySelector("#Page_0_Project_Found_widget #addressAppend") as HTMLElement
            addressAppend.textContent =
              minPriorityObject.FarmStreetAddress1 +
              ", " +
              minPriorityObject.FarmCity +
              ", " +
              minPriorityObject.FarmStateAbbreviation
            storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
            storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
            storage.rawSet("FarmCity", minPriorityObject.FarmCity)
            storage.set("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
            storage.set("FarmName", minPriorityObject.FarmName)
            storage.set("FarmID", minPriorityObject.FarmID)
            storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
            storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
            storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
            storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
            storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
            storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
            storage.rawSet("FarmPayment", minPriorityObject.FarmPayment)
          }
        }
      })
      .catch((error) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from HubDB:", error)
      })
  }

  async function locSaveSessionDetailsOnLocalStorage(exampleUtilityId: any): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","locSaveSessionDetailsOnLocalStorage",[exampleUtilityId],["exampleUtilityId"]);
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: String(exampleUtilityId),
    })
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    if (rows.length >= 1) {
      storage.set("Config ID", rows[0].id)
      rows.forEach((element: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.set("SessionDetails", JSON.stringify(element.values))
          if (element.values["24"] !== undefined) {
            storage.set("credentialProvider", element.values["24"].name)
          }
          storage.set("stateForLMIConfig", element.values["13"].name)
          storage.set("UtilitySessionDetails", JSON.stringify(element.values))
          storage.set("UtilityRate", element.values["78"])
          storage.set("SubSizingFactor", element.values["79"])
          storage.set("standardRate", element.values["80"])
          storage.set("lmiNseRate", element.values["81"])
          storage.set("standardRate", element.values["80"])
          storage.set("lmiNseRate", element.values["81"])
          storage.set("acSystemSize", element.values["82"])
          storage.set("acKwh", element.values["84"])
        } else {
          // (original left this branch empty)
        }
      })
    }
  }

  async function addDataToContactRecord(email: any): Promise<boolean> {
__ea_trace("modules/entry/entry-returning.ts","addDataToContactRecord",[email],["email"]);
    const checkUID1 = storage.get("utility_id")
    const UserDevice_1 = storage.get("User Device")
    const BrowserName_1 = storage.get("Browser Name")
    const opratingSystem_1 = storage.get("Operating System")
    let catchdata: any = ""
    try {
      const data = {
        properties: {
          email: email,
          internal_contact_source: "enrollment website",
          enrollment_utility_id: checkUID1,
          user_agent: BrowserName_1,
          user_device: UserDevice_1,
          user_agent___operating_system: opratingSystem_1,
          first_visited_url: first_visited_url,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      // (original assigned response.json() without awaiting — preserved)
      responseFromAPI = response.json()
      responseFromAPI = JSON.stringify(responseFromAPI)
      if (response.ok) {
        loggetAvalability()
      }
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  /*** --------------------------- variations my info code ---------------------------------- ****/
  async function loggetAvalability(): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","loggetAvalability",[],[]);
    const exampleUtilityId = storage.get("utility_id")
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: String(exampleUtilityId),
    })
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    let IsUtilityIdMatched = false
    void IsUtilityIdMatched
    if (rows.length >= 1) {
      storage.rawSet("Session Config ID", rows[0].id)
      rows.forEach((element: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.set("SessionDetails", JSON.stringify(element.values))
          storage.set("stateForLMIConfig", element.values["13"].name)
          storage.set("UtilitySessionDetails", JSON.stringify(element.values))
          storage.set("UtilityRate", element.values["78"])
          storage.set("SubSizingFactor", element.values["79"])
          storage.set("standardRate", element.values["80"])
          storage.set("lmiNseRate", element.values["81"])
          storage.set("acSystemSize", element.values["82"])
          storage.set("acKwh", element.values["84"])
          IsUtilityIdMatched = true
          utilityIdSession = element.values["1"]
          if (element.values["68"]) {
            LMICensusTractLevels = element.values["68"].name
          }
          if (element.values["30"] === "1") {
            LmiAvailability = "Yes"
          } else if (element.values["30"] === "0") {
            LmiAvailability = "No"
          } else {
            LmiAvailability = ""
          }
          if (element.values["31"] === "1") {
            LmiCensusAvailability = "Yes"
          } else if (element.values["31"] === "0") {
            LmiCensusAvailability = "No"
          } else {
            LmiCensusAvailability = ""
          }
          logcheckLMIConfigurationVariation()
        } else {
          // (original left this branch empty)
        }
      })
    } else {
      // (original left this branch empty)
    }
  }

  // check variation for the LMI page ----------------------------------------------
  async function logcheckLMIConfigurationVariation(): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","logcheckLMIConfigurationVariation",[],[]);
    // (original left the LMI HubDB lookup + redirection logic commented out here)
    await logcheckUsageConfigurationVariation()
    await logcheckConsentConfigurationVariation()
  }

  async function logcheckUsageConfigurationVariation(): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","logcheckUsageConfigurationVariation",[],[]);
    let usageAvaiablity: any
    let rows: any
    const SessionLocalStorage = await JSON.parse(storage.get("UtilitySessionDetails") ?? "null")
    if (SessionLocalStorage["32"] === 0) {
      usageAvaiablity = "No"
    } else if (SessionLocalStorage["32"] === 1) {
      usageAvaiablity = "Yes"
    } else {
      usageAvaiablity = ""
    }
    void usageAvaiablity
    try {
      const hubDBEndpoint = hubdbRowsUrl("usageConfig", {
        usage_required_for_contract__eq: "Yes",
        origin_type__eq: sampleOriginType,
        session_type__eq: sampleSessiontype,
      })
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      rows = data.objects
      if (rows.length >= 1) {
        if (rows[0].values["5"].name === "Yes") {
          DisplayUsageElementList.push("UTILITY CREDENTIALS DISPLAY")
        }
        if (rows[0].values["7"].name === "Yes") {
          DisplayUsageElementList.push("CREATE UTILITY ACCOUNT DISPLAY")
        }
        if (rows[0].values["9"].name === "Yes") {
          DisplayUsageElementList.push("SKIP FOR NOW DISPLAY")
        }
        if (rows[0].values["11"].name === "Yes") {
          DisplayUsageElementList.push("UTILITY ACCOUNT NUMBER DISPLAY")
        }
        if (rows[0].values["13"].name === "Yes") {
          DisplayUsageElementList.push("BILL UPLOAD DISPLAY")
        }

        if (rows[0].values["6"].name === "Yes") {
          requireUsageElementList.push("UTILITY CREDENTIALS REQUIRED")
        }
        if (rows[0].values["8"].name === "Yes") {
          requireUsageElementList.push("CREATE UTILITY ACCOUNT REQUIRED")
        }
        if (rows[0].values["10"].name === "Yes") {
          requireUsageElementList.push("SKIP FOR NOW REQUIRED")
        }
        if (rows[0].values["12"].name === "Yes") {
          requireUsageElementList.push("UTILITY ACCOUNT NUMBER REQUIRED")
        }
        if (rows[0].values["14"].name === "Yes") {
          requireUsageElementList.push("BILL UPLOAD REQUIRED")
        }

        storage.set("usageDisplayelementList", JSON.stringify(DisplayUsageElementList))
        storage.set("usagerequireElementList", JSON.stringify(requireUsageElementList))
        if (DisplayUsageElementList.length > 1) {
          // (original left this branch empty)
        } else {
          // (original left this branch empty)
        }
      } else {
        storage.set("usageDisplayelementList", JSON.stringify(DisplayUsageElementList))
        storage.set("usagerequireElementList", JSON.stringify(requireUsageElementList))
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }

  async function logcheckConsentConfigurationVariation(): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","logcheckConsentConfigurationVariation",[],[]);
    let rows: any
    const SessionLocalStorage = JSON.parse(storage.get("UtilitySessionDetails") ?? "null")
    if (SessionLocalStorage["33"] === 0) {
      consetPaymentReq = "No"
    } else if (SessionLocalStorage["33"] === 1) {
      consetPaymentReq = "Yes"
    } else {
      consetPaymentReq = "No"
    }
    const hubDBEndpoint = hubdbRowsUrl("paymentConfig", {
      payment_required_for_billing__eq: consetPaymentReq,
      origin_type__eq: sampleOriginType,
      session_type__eq: sampleSessiontype,
    })
    try {
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      rows = data.objects
      if (rows.length >= 1) {
        if (rows[0].values["5"].name === "Yes") {
          DisplayConsentElementList.push("PAYMENT OPTIONS DISPLAY")
        }
        if (rows[0].values["7"].name === "Yes") {
          DisplayConsentElementList.push("AUTHORIZATION CONSENT DISPLAY")
        }
        if (rows[0].values["9"].name === "Yes") {
          DisplayConsentElementList.push("CREDIT CHECK CONSENT DISPLAY")
        }
        if (rows[0].values["11"].name === "Yes") {
          DisplayConsentElementList.push("SUBSCRIPTION SIGNATURE DISPLAY")
        }
        if (rows[0].values["13"].name === "Yes") {
          DisplayConsentElementList.push("SUB ACKNOWLEDGMENT DISPLAY")
        }
        if (rows[0].values["15"].name === "Yes") {
          DisplayConsentElementList.push("DISCLOSURE SIGNATURE DISPLAY")
        }
        if (rows[0].values["17"].name === "Yes") {
          DisplayConsentElementList.push("DISC ACKNOWLEDGMENT DISPLAY")
        }
        if (rows[0].values["19"].name === "Yes") {
          DisplayConsentElementList.push("SUBSCRIPTION SIGNATURE SIGN DISPLAY")
        }
        if (rows[0].values["21"].name === "Yes") {
          DisplayConsentElementList.push("DISCLOSURE SIGNATURE SIGNED DISPLAY")
        }

        if (rows[0].values["6"].name === "Yes") {
          requireConsentElementList.push("PAYMENT OPTIONS REQUIRED")
        }
        if (rows[0].values["8"].name === "Yes") {
          requireConsentElementList.push("AUTHORIZATION CONSENT REQUIRED")
        }
        if (rows[0].values["10"].name === "Yes") {
          requireConsentElementList.push("CREDIT CHECK CONSENT REQUIRED")
        }
        if (rows[0].values["12"].name === "Yes") {
          requireConsentElementList.push("SUBSCRIPTION SIGNATURE REQUIRED")
        }
        if (rows[0].values["14"].name === "Yes") {
          requireConsentElementList.push("SUB ACKNOWLEDGMENT REQUIRED")
        }
        if (rows[0].values["16"].name === "Yes") {
          requireConsentElementList.push("DISCLOSURE SIGNATURE REQUIRED")
        }
        if (rows[0].values["18"].name === "Yes") {
          requireConsentElementList.push("DISC ACKNOWLEDGMENT REQUIRED")
        }
        if (rows[0].values["20"].name === "Yes") {
          requireConsentElementList.push("SUBSCRIPTION SIGNATURE SIGN REQUIRED")
        }
        if (rows[0].values["22"].name === "Yes") {
          requireConsentElementList.push("DISCLOSURE SIGNATURE SIGNED REQUIRED")
        }
        storage.set("consentDisplayelementList", JSON.stringify(DisplayConsentElementList))
        storage.set("consentrequireElementList", JSON.stringify(requireConsentElementList))
        if (DisplayConsentElementList.length > 1) {
          // (original left this branch empty)
        } else {
          // (original left this branch empty)
        }
      } else {
        storage.set("consentDisplayelementList", JSON.stringify(DisplayConsentElementList))
        storage.set("consentrequireElementList", JSON.stringify(requireConsentElementList))
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  /*** ----------------------------------------- variations my info code ----------------------------------------- ****/

  async function addUserAgentData(): Promise<boolean> {
__ea_trace("modules/entry/entry-returning.ts","addUserAgentData",[],[]);
    const checkZC1 = storage.get("zip_code")
    const state1 = storage.get("FarmStateAbbreviation")
    const county = storage.get("county")
    void county
    const UserDevice_1 = storage.get("User Device")
    const BrowserName_1 = storage.get("Browser Name")
    const opratingSystem_1 = storage.get("Operating System")
    let catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: globalDealId,
          user_agent: BrowserName_1,
          user_device: UserDevice_1,
          user_agent___operating_system: opratingSystem_1,
          service_state_abbreviation: state1,
          postal_code: checkZC1,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        await CheckDealStageAndRedirectAccordingly()
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  // ------------- get Deal stage and redirect the page accordingly -----------------
  async function CheckDealStageAndRedirectAccordingly(): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","CheckDealStageAndRedirectAccordingly",[],[]);
    let email = fieldVal("#loginForm #email")
    email = email.toLowerCase()
    let catchdata: any = ""
    try {
      const data = { deal_id: globalDealId }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
        returningUsercloseLoader()
        q("#userNotExist").innerHTML =
          "We were unable to find an account using that user name and password. Please try again or use Forgot Password"
      } else if (dataa.message === "User Found") {
        returningUsercloseLoader()
        const skipUsageSubmission = dataa.userValue.properties.skip_usage_submission
        const skipBayouSubmission = dataa.userValue.properties.skip_bayou_submission
        const lmiMyUsage = dataa.userValue.properties.lmi_my_usage
        const userDealStage = dataa.userValue.properties.dealstage
        const serviceStateAbbreviation = dataa.userValue.properties.service_state_abbreviation
        if (serviceStateAbbreviation === "IL") {
          if (userDealStage === "984278684" || userDealStage === "984278685") {
            window.location.href = "/il-usage"
          } else if (userDealStage === "984278686" || userDealStage === "984278687" || userDealStage === "984278688") {
            window.location.href = "/il-my-consent"
          }
        } else {
          const storedItem = storage.get("skipUsage")
          void storedItem
          const credentialProvider = storage.get("credentialProvider")
          if (skipUsageSubmission === "Yes") {
            storage.set("skipUsage", "Yes")
          } else {
            storage.set("skipUsage", "No")
          }
          if (skipUsageSubmission === "Yes" && skipBayouSubmission === "Yes" && userDealStage === "127892571") {
            window.location.href = "/myusageverification"
          } else if (skipUsageSubmission === "Yes" && userDealStage === "127892571") {
            window.location.href = "/my-usage-verification"
          } else if (userDealStage === "1142098958") {
            window.location.href = "/myusageachverification"
          } else if (userDealStage === "1142098957") {
            window.location.href = "/ach-verification-page"
          } else {
            if (userDealStage === "157471035") {
              storage.rawSet("mil", "MilCT") // LMI Census Tract (Sales Pipeline)
              window.location.href = "/my-info"
            } else if (userDealStage === "127892566") {
              storage.rawSet("mil", "MiLM") // LMI Manual (Sales Pipeline)
              window.location.href = "/my-info"
            } else if (userDealStage === "127892569" && lmiMyUsage === "yes" && credentialProvider === "NSE (Hansen)") {
              window.location.href = "/my-usage"
            } else if (userDealStage === "127892569" && lmiMyUsage === "yes" && credentialProvider === "Bayou") {
              window.location.href = "/my_usage"
            } else if (userDealStage === "127892569" && credentialProvider === "Bayou") {
              window.location.href = "/myusage"
            } else if (userDealStage === "127892569" && credentialProvider === "NSE (Hansen)") {
              window.location.href = "/my-usage"
            } else if (userDealStage === "127892569") {
              window.location.href = "/my-usage"
            } else if (userDealStage === "127892568") {
              storage.rawSet("rp", "QxtVq") // Consent All (Sales Pipeline)
              window.location.href = "/my-consent"
            } else if (userDealStage === "127892567") {
              storage.rawSet("rp", "NpEv") // Consent Signature (Sales Pipeline)
              window.location.href = "/my-consent"
            } else if (userDealStage === "127892570") {
              storage.rawSet("typ", "lMiAsTaNc") // Lmi thankyou page
              window.location.href = "/thank-you"
            } else if (userDealStage === "127892578") {
              userNoLongerOpenLoader()
              await delay(9000)
              userNoLongercloseLoader()
              clearDatabase()
            } else {
              window.location.href = "/my-info"
            }
          }
        }
      }
      if (response.status === 500 || response.status === 404) {
        returningUsercloseLoader()
        q("#userNotExist").innerHTML =
          "We were unable to find an account using that user name and password. Please try again or use Forgot Password"
      }
    } catch (error) {
      returningUsercloseLoader()
      q("#userNotExist").innerHTML =
        "We were unable to find an account using that user name and password. Please try again or use Forgot Password"
      console.error("Error:", error)
    }
  }
  // ------------- get Deal stage and redirect the page accordingly -----------------

  // NOTE: the inline script awaited a bare `delay(9000)` it never declared (a
  // latent ReferenceError on the 127892578 branch). Defined here to match the
  // clearly-intended helper (used above).
  async function delay(ms: number): Promise<void> {
__ea_trace("modules/entry/entry-returning.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  // ─── Dead LMI-availability path (getAvailability() call was commented out) ──────
  function getAvailability(): void {
__ea_trace("modules/entry/entry-returning.ts","getAvailability",[],[]);
    const exampleUtilityId = "LMI-TST-3-ID"
    const allUtilityRows: any[] = []
    void allUtilityRows
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability")
    fetch(hubDBEndpoint, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[data],["data"]);
        const rows = data.objects
        if (rows.length >= 1) {
          rows.forEach((element: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[element],["element"]);
            if (exampleUtilityId === element.values["3"]) {
              utilityIdSession = element.values["3"]
              if (element.values["31"] === "1") {
                LmiAvailability = "Yes"
              } else if (element.values["31"] === "0") {
                LmiAvailability = "No"
              } else {
                LmiAvailability = ""
              }
              if (element.values["32"] === "1") {
                LmiCensusAvailability = "Yes"
              } else if (element.values["32"] === "0") {
                LmiCensusAvailability = "No"
              } else {
                LmiCensusAvailability = ""
              }
              checkLMIConfigurationVariation()
              return
            }
          })
        } else {
          return
        }
      })
      .catch((error) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from Utility session:", error)
      })
  }
  void getAvailability

  function checkLMIConfigurationVariation(): void {
__ea_trace("modules/entry/entry-returning.ts","checkLMIConfigurationVariation",[],[]);
    sampleOriginType = "Direct"
    sampleSessiontype = "Consumer Only"
    const hubDBEndpoint = hubdbRowsUrl("lmiCensus")
    fetch(hubDBEndpoint, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[data],["data"]);
        const rows = data.objects
        if (rows.length >= 1) {
          let foundMatch = false
          void foundMatch
          rows.forEach((element: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[element],["element"]);
            if (
              LmiAvailability === element.values["3"].name &&
              LmiCensusAvailability === element.values["4"].name &&
              sampleOriginType === element.values["5"].name &&
              sampleSessiontype === element.values["6"].name
            ) {
              if (element.values["7"].name === "Yes") {
                DisplayElementList.push("INCOME EXCEED DISPLAY")
              }
              if (element.values["9"].name === "Yes") {
                DisplayElementList.push("PROGRAM PARTICIPATION DISPLAY")
              }
              if (element.values["11"].name === "Yes") {
                DisplayElementList.push("REQUEST INCOME DISPLAY")
              }
              if (element.values["13"].name === "Yes") {
                DisplayElementList.push("SKIP LMI DISPLAY")
              }

              if (element.values["8"].name === "Yes") {
                requireElementList.push("INCOME EXCEED REQUIRED")
              }
              if (element.values["10"].name === "Yes") {
                requireElementList.push("PROGRAM PARTICIPATION REQUIRED")
              }
              if (element.values["12"].name === "Yes") {
                requireElementList.push("REQUEST INCOME REQUIRED")
              }
              if (element.values["14"].name === "Yes") {
                requireElementList.push("SKIP LMI REQUIRED")
              }
              foundMatch = true
              return
            } else {
              // (original left this branch empty)
            }
          })
        } else {
          // (original left this branch empty)
        }
      })
      .then(() => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[],[]);
        if (DisplayElementList.length > 1) {
          // (original left this branch commented out)
        } else {
          // (original left this branch commented out)
        }
      })
      .catch((error) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[error],["error"]);
        void error
      })
  }
  void checkLMIConfigurationVariation

  // ─── IndexedDB glue (defines this page's own clearDatabase) ───────────────────
  const request = indexedDB.open("myDatabase", 1)
  let db: any

  request.onerror = (event: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${event.target.errorCode}`)
  }

  request.onsuccess = (event: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[event],["event"]);
    db = event.target.result
  }

  request.onupgradeneeded = (event: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[event],["event"]);
    const db = event.target.result
    const objectStore = db.createObjectStore("files", { autoIncrement: true })
    objectStore.createIndex("name", "name", { unique: false })
  }

  function clearDatabase(): void {
__ea_trace("modules/entry/entry-returning.ts","clearDatabase",[],[]);
    const transaction = db.transaction(db.objectStoreNames, "readwrite")
    transaction.oncomplete = () => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[],[]);
    }
    transaction.onerror = (event: any) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[event],["event"]);
    }
    Array.from(db.objectStoreNames as DOMStringList).forEach((storeName) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[storeName],["storeName"]);
      const objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }

  // ─── Wiring (was top-level in the inline script) ──────────────────────────────
  // Initial view: show the returning-user widget when the URL carries `?rupapr`,
  // otherwise show the enter-zip widget. These target the sibling entry widgets
  // and this module's own page-level widget wrapper, so they stay document-scoped.
  const currentUrll = window.location.href
  const parts = currentUrll.split("?")
  if (parts[1] === "rupapr") {
    ;(document.querySelector("#Page_0_Enter_Zip_widget") as HTMLElement).style.display = "none"
    ;(document.querySelector("#Page_0_Project_Found_widget") as HTMLElement).style.display = "none"
    ;(document.querySelector("#Page_0_Project_not_Found_widget") as HTMLElement).style.display = "none"
    ;(document.querySelector("#page_0_returning_user_widget") as HTMLElement).style.display = "block"
  } else {
    ;(document.querySelector("#Page_0_Enter_Zip_widget") as HTMLElement).style.display = "block"
    ;(document.querySelector("#Page_0_Project_Found_widget") as HTMLElement).style.display = "none"
    ;(document.querySelector("#Page_0_Project_not_Found_widget") as HTMLElement).style.display = "none"
    ;(document.querySelector("#page_0_returning_user_widget") as HTMLElement).style.display = "none"
  }

  qi("#email").addEventListener("input", validateEmail)
  qi("#password").addEventListener("input", validatePasswordRU)
  q("#lg_submit").addEventListener("click", validateForm)

  qi("#email").addEventListener("keypress", (event) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[event],["event"]);
    if (event.key === "Enter") {
      validateForm()
    }
  })
  qi("#password").addEventListener("keypress", (event) => {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[event],["event"]);
    if (event.key === "Enter") {
      validateForm()
    }
  })

  const togglePassword = q("#togglePassword")
  const password = qi("#password")
  togglePassword.addEventListener("click", function (this: HTMLElement) {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[this],["this"]);
    const type = password.getAttribute("type") === "password" ? "text" : "password"
    password.setAttribute("type", type)
    this.classList.toggle("fa-eye-slash")
  })
  $(root)
    .find("form i#togglePassword")
    .on("click", function (this: HTMLElement) {
__ea_trace("modules/entry/entry-returning.ts","(anon)",[this],["this"]);
      $(this).toggleClass("colored")
    })
}
